import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "image", "caption"]
  static classes = ["open", "closed"]
  static values = { event: { type: String, default: "lightbox:open" } }

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    this.onRequest = this.onRequest.bind(this)

    window.addEventListener("keydown", this.onKeydown)
    window.addEventListener(this.eventValue, this.onRequest)
  }

  disconnect() {
    window.removeEventListener("keydown", this.onKeydown)
    window.removeEventListener(this.eventValue, this.onRequest)
  }

  open(event) {
    event?.preventDefault()

    this.show(this.detailsFrom(event))
  }

  close() {
    if (!this.isOpen) return

    this.overlay.classList.add(...this.closedClassList)
    this.overlay.classList.remove(...this.openClassList)
    this.imageTarget.removeAttribute("src")

    this.opener?.focus()
    this.opener = null
  }

  toggle(event) {
    this.isOpen ? this.close() : this.open(event)
  }

  show({ src, alt, caption } = {}) {
    if (!src) return

    this.imageTarget.src = src
    this.imageTarget.alt = alt || ""

    if (this.hasCaptionTarget) this.captionTarget.textContent = caption ?? alt ?? ""

    this.overlay.classList.remove(...this.closedClassList)
    this.overlay.classList.add(...this.openClassList)
    this.overlay.focus()
  }

  onRequest(event) {
    this.opener = document.activeElement
    this.show(event.detail || {})
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  detailsFrom(event) {
    const trigger = event?.currentTarget
    const params = event?.params || {}
    const image = trigger?.matches?.("img") ? trigger : trigger?.querySelector?.("img")

    this.opener = trigger

    return {
      src: params.src || trigger?.href || image?.currentSrc || image?.src,
      alt: params.alt ?? image?.alt,
      caption: params.caption
    }
  }

  get overlay() {
    return this.hasOverlayTarget ? this.overlayTarget : this.element
  }

  get isOpen() {
    return !this.closedClassList.some((name) => this.overlay.classList.contains(name))
  }

  get openClassList() {
    return this.hasOpenClass ? this.openClasses : ["flex"]
  }

  get closedClassList() {
    return this.hasClosedClass ? this.closedClasses : ["hidden"]
  }
}
